import { SCALE_CSS_VAR } from './scale';

/**
 * PLA-8844: the scale factor the Intelligence screens shrink by on a narrow content column.
 *
 * The column, not the viewport. The 489px Orbit panel is a flex sibling of the route's content
 * (OrbitShell), so opening it takes that width off the column while the viewport is unchanged -
 * 1366 with the panel open leaves 677px of usable column, which is narrower than 1024 with it
 * closed. Measuring the scope root is the only reading that sees both causes at once.
 */

/** At or above this column width the screens render at their drawn size. */
export const SCALE_MAX_WIDTH = 1200;

/** At or below this column width the screens render at SCALE_MIN. */
export const SCALE_MIN_WIDTH = 800;

export const SCALE_MAX = 1;

export const SCALE_MIN = 0.75;

/** Three decimals: enough that a 32px token lands within a hundredth of a px, short enough that a
 *  sub-pixel reflow does not rewrite the property. */
const PRECISION = 1000;

export { SCALE_CSS_VAR };

/**
 * The factor for a measured column width: SCALE_MAX at or above SCALE_MAX_WIDTH, falling linearly
 * to SCALE_MIN at or below SCALE_MIN_WIDTH.
 *
 * A width of 0 returns SCALE_MAX. That is the pre-measurement and jsdom reading, and answering 1
 * there means a screen renders at its drawn size until a real measurement replaces it, rather than
 * flashing at the minimum on first paint.
 */
export const computeScale = (width: number): number => {
  if (!Number.isFinite(width) || width <= 0 || width >= SCALE_MAX_WIDTH) {
    return SCALE_MAX;
  }

  if (width <= SCALE_MIN_WIDTH) {
    return SCALE_MIN;
  }

  const progress = (width - SCALE_MIN_WIDTH) / (SCALE_MAX_WIDTH - SCALE_MIN_WIDTH);

  return Math.round((SCALE_MIN + progress * (SCALE_MAX - SCALE_MIN)) * PRECISION) / PRECISION;
};
